import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { LocalDataSource } from 'ng2-smart-table';
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEventType, HttpRequest } from '@angular/common/http';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import { DialogComponent, ButtonPropsModel } from '@syncfusion/ej2-angular-popups';
import 'jquery'
import 'bootstrap'
import { Observable } from 'rxjs';
import { retry } from 'rxjs-compat/operator/retry';
import {  DaoTaos_HocVien } from '../../../routes/menu'

const swal = require('sweetalert');


@Component({
    selector: 'app-dieuhanh-hocthuedit',
  templateUrl: './hocthuedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./hocthuedit.component.scss'],
    providers: [ListService, Repository]
})


export class hocthueditComponent implements OnInit {

  @ViewChild('ejskhoahoc') public ejskhoahoc: DialogComponent;

  @ViewChild('mdChonHocVien') mdChonHocVien: BsModalComponent;
  @ViewChild('chonhocvienedit') chonhocvienedit: any;
  @ViewChild('mdChonLopHoc') mdChonLopHoc: BsModalComponent;
  @ViewChild('chonlophocedit') chonlophocedit: any;

  tong_hv: number = 0;
  tong_dihoc: number = 0;
  tong_nghihoc: number = 0;

  doituongSelect: any = {
    Id: null, DonViId: null, LopId: null, NgayHoc: null
    , DayChinhId: null, TroGiang1Id: null, DoTuoi: null, GhiChu: null
    , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , ChiTiets: [], TenLop: null
  };       
  
  inputGiangViens: any;
  
 
  dslops: any;
  dschinhanhs: any;
  doituongkethua: any;
  doanhnghiepid: string = null;
  @Output() save: EventEmitter<any> = new EventEmitter();
  datas: any;
  data: any;
  public dulieu: any = { dataGrid: null, dataGridTimKiem: null, datatieude: null, sobanghi: null };
  indLoading: boolean = false;
  dataFrm: FormGroup;
  modalTitle: string;
  modalBtnTitle: string;
  Id: string;
  NgayHienTai: Date = new Date();
  inputDonVi: any;
  public DonViDropId: any = { Id: null, Ten: null };
  public TaiKhoanDropId: any = { Id: null, Ten: null };
  TaiKhoanId: any;
  selecteddonvis: any;
  selectedchuongs: any;
  selectedkhoans: any;
  Ma_Tai_Khoan: any;
  dropdownList_DonVi = [];
  inputTaiKhoan: any;
  dropdownList_TaiKhoan = [];
  selectedItems = [];
  dropdownSettings = {};
  khoangthoigian: number = 0;
  tabselected: number = 1;
  inputthangs: any = [
    { text: "Hôm nay", value: 0 },
    { text: "Tháng 1", value: 1 },
    { text: "Tháng 2", value: 2 },
    { text: "Tháng 3", value: 3 },
    { text: "Tháng 4", value: 4 },
    { text: "Tháng 5", value: 5 },
    { text: "Tháng 6", value: 6 },
    { text: "Tháng 7", value: 7 },
    { text: "Tháng 8", value: 8 },
    { text: "Tháng 9", value: 9 },
    { text: "Tháng 10", value: 10 },
    { text: "Tháng 11", value: 11 },
    { text: "Tháng 12", value: 12 },
    { text: "Quý I", value: 13 },
    { text: "Quý II", value: 14 },
    { text: "Quý III", value: 15 },
    { text: "Quý IV", value: 16 },
    { text: "Tuần này", value: 17 },
    { text: "Tháng này", value: 18 },
    { text: "Năm nay", value: 19 },
    { text: "Đầu năm đến nay", value: 20 },
    { text: "Năm trước", value: 21 },

  ];
  dstrangthais: any = [
    { Ten: 'Nghỉ học', Id: 0 },
    { Ten: 'Học bình thường', Id: 1 },
    { Ten: 'Bảo lưu', Id: 2 },
    { Ten: 'Chưa thuộc lớp nào', Id: 3 }

  ];
  public thangs: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },
    { text: "5", value: 5 },
    { text: "6", value: 6 },
    { text: "7", value: 7 },
    { text: "8", value: 8 },
    { text: "9", value: 9 },
    { text: "10", value: 10 },
    { text: "11", value: 11 },
    { text: "12", value: 12 }
  ];

  public quys: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },

  ];

  public nams: Array<{ text: string, value: number }> = [
    { text: (this.NgayHienTai.getFullYear() - 3).toString(), value: (this.NgayHienTai.getFullYear() - 3) },
    { text: (this.NgayHienTai.getFullYear() - 2).toString(), value: (this.NgayHienTai.getFullYear() - 2) },
    { text: (this.NgayHienTai.getFullYear() - 1).toString(), value: (this.NgayHienTai.getFullYear() - 1) },
    { text: this.NgayHienTai.getFullYear().toString(), value: this.NgayHienTai.getFullYear() },
    { text: (this.NgayHienTai.getFullYear() + 1).toString(), value: (this.NgayHienTai.getFullYear() + 1) },
    { text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
    { text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

  ];

  public chons: Array<{ text: string, value: number }> = [
    { text: "Theo ngày", value: 1 },
    { text: "Theo tháng", value: 2 },
    { text: "Theo quý", value: 3 },
    { text: "Theo năm", value: 4 },

  ];
  chongioitinhs: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Nữ" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Nam" }];
  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    Don_Vi_Id: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Id: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , NhanSuId: null
    , BaoCaoId: null
    , TrangThai: null
    , TaiKhoan: null
    , HoTen: null
    , BiDanh: null
    , TenPhuHuynh: null
    , SoDienThoai: null
    , PhuTrach: null
    , DSID: null
    , LopId: null
    , DonViId: null
    , DonVi2Id: null
    , PhuTrachId: null
  };
  public ngaytimkiem: Date = new Date();
  TichTatCa() {
    this.doituongSelect.ChiTiets.forEach((item: any) => {
      item.DiemDanh = !this.TatCa;
    });

    // tính tổng
    if (this.doituongSelect.ChiTiets != null)
      this.tong_hv = this.doituongSelect.ChiTiets.length;
    this.tong_dihoc = 0;
    this.tong_nghihoc = 0;
    this.doituongSelect.ChiTiets.forEach(
      (item) => {
        this.tong_dihoc = this.tong_dihoc + (item.DiemDanh === true ? 1 : 0);
        this.tong_nghihoc = this.tong_nghihoc + (item.DiemDanh === false ? 1 : 0);

      }
    );


  }
  
  

  public changeChiNhanh($event: any) {
    if (typeof $event === "undefined") {
      this.TimKiems.DonViId = null;

    }
    else {
      this.TimKiems.DonViId = $event.Id;
      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.TimKiems.DonViId })
        .subscribe(response => {
          this.dslops = response;
        });
      this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.TimKiems.DonViId })
        .subscribe(response => {
          this.inputGiangViens = response;
        });

    }
  }

  


  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();
  public TuNgay1: Date = new Date();
  public DenNgay1: Date = new Date();
  public tTuNgay: string;
  public tDenNgay: string;

 

 
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: true
  };

  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  phanheid: any;
  lopid: string;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {



  }

  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  
  loadDataInit(pheid: string, id: string, donviid: string, lopid: string) {
    
    this.ngaytimkiem = null;
    this.StartPage = 1;
    this.EndPage = 20;
    this.ngaytimkiem = null;
    this.innerHeight = window.innerHeight - 250;
    this.phanheid = pheid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = this.currentUser.id_don_vi;
      this.TimKiems.DonViId = this.donviid;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === this.phanheid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
       
      }
     
      
    }

    this.repo.postRequest('api/login/gettrungtam2s', { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.dschinhanhs = response;
      });

    this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.donviid })
      .subscribe(response => {
        this.inputGiangViens = response;
      });
    this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.donviid })
      .subscribe(response => {
        this.dslops = response;

      });


    this.doituongSelect = {
      Id: null, DonViId: null, LopId: null, NgayHoc: null
      , DayChinhId: null, TroGiang1Id: null, DoTuoi: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , ChiTiets: [], TenLop: null
    };

    if (donviid != null)
      this.doituongSelect.DonViId = parseInt(donviid);
    else
      this.doituongSelect.DonViId = parseInt(this.currentUser.id_don_vi);



    if (id === null) {


      this.doituongSelect.NgayHoc = new Date();
      if (lopid != null)
        this.doituongSelect.LopId = parseInt(lopid);
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;

      this.repo.postRequest("api/hocthu/getbyid/", { IdGuid: id, UserName: this.currentUser.user_name, LopId: this.doituongSelect.LopId })
        .subscribe(response => {
          this.doituongSelect.ChiTiets = response.ChiTiets;

          // tính tổng
          if (this.doituongSelect.ChiTiets != null)
            this.tong_hv = this.doituongSelect.ChiTiets.length;
          this.tong_dihoc = 0;
          this.tong_nghihoc = 0;
          this.doituongSelect.ChiTiets.forEach(
            (item) => {
              this.tong_dihoc = this.tong_dihoc + (item.DiemDanh === true ? 1 : 0);
              this.tong_nghihoc = this.tong_nghihoc + (item.DiemDanh === false ? 1 : 0);

            }
          );

        });

    }
    else {
      console.log("t11");
      this.repo.postRequest("api/hocthu/getbyid/", { IdGuid: id, UserName: this.currentUser.user_name, LopId: this.doituongSelect.LopId })
        .subscribe(response => {
          console.log(response);
          this.doituongSelect.Id = id;
          this.doituongSelect.LopId = response.LopId;
          this.doituongSelect.DonViId = response.DonViId;
          this.doituongSelect.TenLop = response.TenLop;
          this.doituongSelect.DayChinhId = response.DayChinhId;
          this.doituongSelect.TroGiang1Id = response.TroGiang1Id;
          //this.doituongSelect.TroGiang2Id = response.TroGiang2Id;
          //this.doituongSelect.TroGiang3Id = response.TroGiang3Id;
          this.doituongSelect.DoTuoi = response.DoTuoi;
          this.doituongSelect.GhiChu = response.GhiChu;
          this.doituongSelect.TrangThai = response.TrangThai;


          this.doituongSelect.Created = response.Created;
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;

          this.doituongSelect.ChiTiets = response.ChiTiets;

          // this.doituongSelect.TrangThai = response.TrangThai==1?true:0;

          if (response.NgayHoc != null)
            this.doituongSelect.NgayHoc = new Date(response.NgayHoc);
          else
            this.doituongSelect.NgayHoc = null;


          // tính tổng
          if (this.doituongSelect.ChiTiets != null)
            this.tong_hv = this.doituongSelect.ChiTiets.length;
          this.tong_dihoc = 0;
          this.tong_nghihoc = 0;
            this.doituongSelect.ChiTiets.forEach(
              (item) => {
                this.tong_dihoc = this.tong_dihoc + (item.DiemDanh === true ? 1 : 0);
                this.tong_nghihoc = this.tong_nghihoc + (item.DiemDanh === false ? 1 : 0);

              }
            );


        });
    }

  
        
    
  }

  
    
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }
    this.LoadCategory();
  }

  LoadCategory(): void {

  }
  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  maxcot: number = 13;

  onDoiTuongChange($event) {

  }

  inputtrangthais: any = [
    { Id: 1, Ten: 'Mới' }
    , { Id: 9, Ten: 'Không nghe máy' }
    , { Id: 10, Ten: 'Gọi lại sau' }
    , { Id: 5, Ten: 'Quan tâm' }
    , { Id: 12, Ten: 'Tiềm năng' }
    , { Id: 13, Ten: 'Không tiềm năng' }
    , { Id: 2, Ten: 'Đợi học thử' }
    , { Id: 4, Ten: 'Đang học thử' }
    , { Id: 16, Ten: 'Đã học thử' }
    , { Id: 8, Ten: 'Đợi test' }
    , { Id: 3, Ten: 'Đợi đăng ký' }
    , { Id: 7, Ten: 'Đã đăng ký' }
    , { Id: 14, Ten: 'Hủy lịch học thử' }
    , { Id: 11, Ten: 'Hủy lịch test' }
    , { Id: 15, Ten: 'Đã test' }
    , { Id: 6, Ten: 'Không có nhu cầu' }
  ];

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;

  public save_chondoituong2(item: any) {
    let tdoituong = [];
    tdoituong.push(item);
    this.save.emit(tdoituong);
  }
  public save_chondoituong() {  
    let tdoituong = [];
    this.save.emit(tdoituong);

    //this.datas.forEach(
    //  (item) => {
    //    if (item.Tich === true)
    //      tdoituong.push(item);
    //  }
    //);
    //if (tdoituong != null && tdoituong.length > 0)
    //  this.savect.emit(tdoituong);
    //else
    //  this.savect.emit(null);

  }
  closeModal_chondoituong() {
    let tdoituong =null;
    this.save.emit(tdoituong);
  }
  nhomdoituongid: string;
  onLoaiNguoiNop(row: any) {
    this.nhomdoituongid = row.Id;
    //console.log(loai);
  }

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
   
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }

  public changeTrangThai($event: any, index: number) {
    if (typeof $event === "undefined") {
      this.doituongSelect.ChiTiets[index].TrangThai = null;
    }
    else {
      this.doituongSelect.ChiTiets[index].TrangThai = $event.Ten;
    }
  }


  public saveproduct() {

   
    if (this.doituongSelect.DonViId === null) {
      swal('Cảnh báo!', "Bạn chưa chọn chi nhánh!!!", 'warning');
      return;
    }
    //if (this.doituongSelect.LopId === null) {
    //  swal('Cảnh báo!', "Bạn chưa chọn lớp!!!", 'warning');
    //  return;
    //}



    if (this.doituongSelect.DayChinhId === null) {
      swal('Cảnh báo!', "Bạn chưa chọn giáo viên dạy chính!!!", 'warning');
      return;
    }
    if (this.doituongSelect.NgayHoc === null) {
      swal('Cảnh báo!', "Bạn chưa nhập ngày học!!!", 'warning');
      return;
    }


    this.repo.postRequest("api/hocthu/addorupdate", this.doituongSelect)
      .subscribe(response => {
        if (response === "OK") {
          swal('Thông báo!', 'Lưu thành công!.', 'success');
          //this.search();
          this.save.emit(null);
        }
        else
          swal('Cảnh báo!', response, 'warning');
      });

  }
  public changeDiemDanh() {
    // tính tổng
    if (this.doituongSelect.ChiTiets != null)
      this.tong_hv = this.doituongSelect.ChiTiets.length;
    this.tong_dihoc = 0;
    this.tong_nghihoc = 0;
    this.doituongSelect.ChiTiets.forEach(
      (item) => {
        this.tong_dihoc = this.tong_dihoc + (item.DiemDanh === true ? 1 : 0);
        this.tong_nghihoc = this.tong_nghihoc + (item.DiemDanh === false ? 1 : 0);

      }
    );

  }

  deleterow(index: string) {
    //console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.doituongSelect.ChiTiets.splice(index, 1);
        }
      });


  }

  ChonHocVien() {
    this.modalTitle = "Thêm học viên vào danh sách học thử";
    this.chonhocvienedit.loadDataInit(this.doituongSelect.LopId, DaoTaos_HocVien.id);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.mdChonHocVien.open();
  }

  saveModal(doituong: any) {
    this.mdChonHocVien.close();
    let thutu = 0;
    if (this.doituongSelect.ChiTiets != null)
      thutu = this.doituongSelect.ChiTiets.length;
    if (doituong !== null && doituong.length > 0) {
      doituong.forEach((item: any) => {
        let chiTiet = this.doituongSelect.ChiTiets.find(
          x => x.NhanSuId === item.Id
        );
        if (!chiTiet) {
          thutu = thutu + 1;
          this.doituongSelect.ChiTiets.push({
            Id: null, HocThuId: null, NhanSuId: item.Id
            , GhiChu: null, DiemDanh: true, HoVaTen: item.HoVaTen
            , TenGoiKhac: item.TenGoiKhac, TenPhuHuynh: item.TenPhuHuynh
            , DienThoaiDiDong: item.DienThoaiDiDong, TrangThai: item.TrangThai, TT: item.TT
            , STT: thutu, PhuTrach: item.PhuTrach
          });
        }
       
      });

      // tính tổng
      if (this.doituongSelect.ChiTiets != null)
        this.tong_hv = this.doituongSelect.ChiTiets.length;
      this.tong_dihoc = 0;
      this.tong_nghihoc = 0;
      this.doituongSelect.ChiTiets.forEach(
        (item) => {
          this.tong_dihoc = this.tong_dihoc + (item.DiemDanh === true ? 1 : 0);
          this.tong_nghihoc = this.tong_nghihoc + (item.DiemDanh === false ? 1 : 0);

        }
      );


    }

  }


  ChonLopHoc() {
    this.modalTitle = "Chọn lớp học";
    this.chonlophocedit.loadDataInit(this.doituongSelect.LopId, DaoTaos_HocVien.id);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.mdChonLopHoc.open();
  }

  saveModal_LopHoc(doituong: any) {
    this.mdChonLopHoc.close();

    if (doituong != null) {
      doituong.forEach((item: any) => {
        this.doituongSelect.TenLop = item.Ten;
        this.doituongSelect.LopId = item.Id;
      });
    }
    


    
  }

  

}
